import { render, staticRenderFns } from "./school-list-filter.vue?vue&type=template&id=efb93922&"
import script from "./school-list-filter.vue?vue&type=script&lang=js&"
export * from "./school-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports